import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import ColumnConfigurationLookup from '../Models/Lookups/ColumnConfigurationLookup';

@NeoModel
export default class ManageColumnSpecComponentVM extends Views.ViewModelBase {

    constructor(
        public fileGroupingFileSpecApiClient =AppService.get(Types.ApiClients.FileGroupingFileSpecApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }
    public managedColumnSpec = new ColumnConfigurationLookup();
    public isReadOnly: boolean = false;

    public async initialise(columnCount?: number, staticFileSpecID?: number, fileSpecProps?: string) {
        this.managedColumnSpec.columnNumber = Number(columnCount);
        if (this.managedColumnSpec.staticColumnSpecID === 0) {
            this.managedColumnSpec.staticFileSpecID = Number(staticFileSpecID)!;
            this.managedColumnSpec.fileSpecPropertiesConcatenated = String(fileSpecProps);
        }
    }

    public setDateReadOnlyInd() {
        this.isReadOnly = this.managedColumnSpec.dataType !== "Datetime";
    }

    public showColumnNumberUpdateInfo() {
        this.managedColumnSpec.updatedColumnCount = true;
    }
}